import { render, staticRenderFns } from "./DemoPolicyTransactionsList.vue?vue&type=template&id=7caf7aa5"
import script from "./DemoPolicyTransactionsList.vue?vue&type=script&lang=js"
export * from "./DemoPolicyTransactionsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports